import { io, Socket } from "socket.io-client";
import { useAuthStore } from "@/store/auth";

let socket: Socket | null = null;

export function connectSocket(): Socket {
  if (socket) return socket;

  socket = io(import.meta.env.VITE_API_URL ?? "http://localhost:4001", {
    // Funcion en vez de valor fijo: relee el token del store en cada intento de
    // (re)conexion, para que la rotacion del access token no rompa la reconexion.
    auth: (cb) => cb({ token: useAuthStore.getState().accessToken }),
  });

  return socket;
}

export function disconnectSocket() {
  socket?.disconnect();
  socket = null;
}

export function getSocket(): Socket | null {
  return socket;
}
